import script from "./subcategory.vue?vue&type=script&setup=true&lang=js"
export * from "./subcategory.vue?vue&type=script&setup=true&lang=js"

import "./subcategory.vue?vue&type=style&index=0&id=4de75042&scoped=true&lang=css"

import exportComponent from "/var/www/html/koboeat/test/customer_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4de75042"]])

export default __exports__